import lozad from 'lozad';
import { varsFromServer } from '../../client_side_injection_vars';

const CURRENT_BUILDING_IDX = 0;
const BUILDING_MAP_ID = 'building-map';

export const loadBuildingMap = () => {
  const buildingMapEl = document.getElementById(BUILDING_MAP_ID);

  const observeMap = lozad(buildingMapEl, {
    async loaded() {
      try {
        const { default: WeMap, BUILDING_PAGE_MAP } = await import('client/javascript/we_map');

        const { mapData: buildings } = varsFromServer;
        const currentBuilding = buildings[CURRENT_BUILDING_IDX];
        const { latitude, longitude } = currentBuilding;

        const buildingMap = new WeMap({
          container: BUILDING_MAP_ID,
          center: { longitude, latitude },
          type: BUILDING_PAGE_MAP,
          zoom: 13,
          scrollZoom: false,
          doubleClickZoom: false,
          padding: { top: 70, bottom: 20, left: 85, right: 85 }
        });

        buildingMap.addPins(buildings);
        buildingMap.setPrimaryPin(CURRENT_BUILDING_IDX);
        buildingMap.setActivePin(CURRENT_BUILDING_IDX);
      } catch (err) {
        console.log('Error loading building page map: ', err); // eslint-disable-line no-console
      }
    }
  });

  observeMap.observe();
};
